import { useEffect, useState } from 'react';
import { LeadsPro } from '../../components/LeadsPro';
import { RequestedLeads } from '../../components/RequestedLeads';
import { LeadDetails } from '../../components/LeadDetails';
import { Lead } from '../../types/lead';

import { Loader2 } from 'lucide-react';
import { Toaster, toast } from 'sonner';
import { useLocation, useSearchParams } from 'react-router-dom';
import { CallAPIGetPromise, CallAPIPostPromise } from 'Common/commaon';
import { getDecodeId } from 'slices/userProfile/thunk';
import { ApplyLeadConfirmation } from 'components/ApplyLeadConfirmation';
import { AcceptedLeads } from 'components/AcceptedLeads';
import { getDecodeUserType } from 'slices/auth/login/thunk';
import axios from 'axios';
import apiUrl from 'slices/apiEndpoint';
import { Alert, AlertDescription } from 'components/ui/alert';
import FeaturePlan from './featureModal';
import { PaymentDeclinedModal } from 'components/DeclinePayment';
import { useSelector } from 'react-redux';
import { selectPaymentProvider, selectUserDetails } from 'slices/userProfile/reducer';
import { stripePromise, stripePromiseTest } from 'slices/apiEndpoint';
import { Elements } from '@stripe/react-stripe-js';
import Projects from './index'
import { LeadListPage } from 'pages/LeadListPage';
import ChatModal from 'Common/ChatModal';
import api from 'Common/api';
import { hasPermission } from 'Common/permissions';
import { PERMISSIONS } from 'Common/constants/permissions';
import './lead-management.css';
type View = 'leads-pro' | 'requested-leads' | 'lead-details';
const NewLeadsPage =()=> {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentView, setCurrentView] = useState<any>('leads-pro');
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
  const [openLeads, setOpenLeads] = useState<any>([]);
  const [AcceptedLeadsList, setAcceptedLeads] = useState<any>([]);
  const [requestedLeads, setRequestedLeads] = useState<Lead[]>([]);
  const [declinedLeadIds, setDeclinedLeadIds] = useState<string[]>([]);
 const [refresh,setIsRefresh]=useState(false)
 const [rejectedCardReson,setRejectedReason]= useState("")
 const [paymentProvider,setPaymentProvider]= useState("")
 const [showPlanModal, setShowPlanModal] = useState(false);
 const [selectedPlan, setSelectedPlan] = useState<number | null>(null);
 const [showPaymentDeclinedModal,setShowPaymentDeclinedModal]=useState(false)
 const [paymentModalMode, setPaymentModalMode] = useState<'checkout' | 'retry'>('checkout')
 const [step, setStep] = useState<"plans" | "confirmation">("plans");
 const [loading,setLoading]=useState(true)
 const user:any = useSelector(selectUserDetails)
 const isEmployee = user[0]?.is_test_stripe_user ===1
 const canViewJobs = hasPermission(PERMISSIONS.VIEW_JOBS);
 const canRespondToJobs = hasPermission(PERMISSIONS.RESPOND_JOB);
 const canAcceptJobs = canRespondToJobs && hasPermission(PERMISSIONS.MANAGE_BILLING);
  const handleViewDetails = (leadId: string) => {
    setSelectedLeadId(leadId);
    setCurrentView('lead-details');
    const next = new URLSearchParams(searchParams);
    next.set('leadId', String(leadId));
    setSearchParams(next, { replace: true });
  };
 const location = useLocation()
 const handleChoosePlan = (index: number) => {
  setSelectedPlan(index);
  setStep("confirmation");
};
const handleCloseModal = () => {
  setShowPlanModal(false);
  setTimeout(() => {
    setStep("plans");
    setSelectedPlan(null);
  }, 300);
};


 useEffect(()=>{
if(location.pathname.includes("pages-projects")){
setCurrentView("leads-pro")
}else{
  if(location.pathname.includes("project-ongoing-leads")){
    setCurrentView("accepted-leads")

  }else{
    setCurrentView("requested-leads")

  }

}
 },[location.pathname])
const paymentprov =useSelector(selectPaymentProvider)

  const openLeadPaymentModal = (lead: any) => {
    setPendingLead(lead)
    setPaymentProvider(paymentprov || paymentProvider || 'stripe')
    setRejectedReason('')
    setPaymentModalMode('checkout')
    setShowApplyConfirmation(false)
    setShowPaymentDeclinedModal(true)
  }

  const handleConfirmApplyLead = (leadId?: string) => {
    if (!canAcceptJobs) return;
    const lead = openLeads.find((l:any) => l.id === leadId);
    if (lead && !loading) {
      openLeadPaymentModal(lead)
    }
  };

  const handleApplyLead = (leadId:any) => {
    if (!canAcceptJobs) return;
    const lead = [...openLeads, ...requestedLeads].find((l:any) => l.id === leadId) as any
    if (lead &&!loading) {
      openLeadPaymentModal(lead)
    }
  };

  const handleDeclineLead = (leadId: string) => {
    if (!canRespondToJobs) return;
    const lead = [...openLeads, ...requestedLeads].find((l:any) => l.id === leadId);
    if (lead &&!loading) {
      setLoading(true)
      const loading = toast.loading("Loading")
      CallAPIPostPromise(`/jobs/declineJob`,{
        contractorId:getDecodeId(),
        jobId:Number(leadId) ,
      }).then(()=>{
        toast.info('Lead Declined', {
          description: `You've declined "${lead.title}". It won't appear in your feed anymore.`
        });
        setIsRefresh(r=>!r)
        toast.dismiss(loading)
      handleBack()

      }).catch((e:any)=>{
        toast.error(e.message, {
          description: e.reason
        });
        toast.dismiss(loading)

      }).finally(()=>{
        setLoading(false)
      })
    
      
    
      
    }
   
  };

 
  const [showApplyConfirmation, setShowApplyConfirmation] = useState(false);
  const [pendingLeadId, setPendingLeadId] = useState<any>(null);
  const [pendingLead, setPendingLead] = useState<any>(null);

  const handleDeclineRequestedLead = (leadId: any) => {
    if (!canRespondToJobs) return;
    const lead = requestedLeads.find(l =>Number(l.id)  === Number(leadId) );

    
    if (lead && !loading) {
      setLoading(true)
      CallAPIPostPromise(`/jobs/declineJob`,{
        contractorId:getDecodeId(),
        jobId:Number(leadId) ,
      }).then((res:any)=>{
      
      setIsRefresh(r=>!r)
      handleBack()
      }).catch((e:any)=>{
        console.log(e)
      }).finally(()=>{
        setLoading(false)
      })
      
      toast.info('Lead Declined', {
        description: `Lead Declined "${lead.title}".`
      });
    }
  };

  const handleBack = () => {
    setSelectedLeadId(null);
    const next = new URLSearchParams(searchParams);
    next.delete('leadId');
    setSearchParams(next, { replace: true });
    if(location.pathname.includes("pages-projects")){
      setCurrentView("leads-pro")
      }else{
        if(location.pathname.includes("project-ongoing-leads")){
          setCurrentView("accepted-leads")
      
        }else{
          setCurrentView("requested-leads")
      
        }
      
      }
  };

  const getSelectedLead = (): Lead | undefined => {
    if (!selectedLeadId) return undefined;
    
    const lead = [...openLeads, ...requestedLeads,...AcceptedLeadsList].find(l => String(l.id) === String(selectedLeadId));
    return lead;
  };

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        setLoading(true);
  
        const leadId = getDecodeId();
        const userType = getDecodeUserType();
  
        const [openRes, requestedRes, acceptedRes] = await Promise.all([
          CallAPIGetPromise(`/jobs/getOpenJobs/${leadId}`),
          CallAPIGetPromise(`/jobs/getRequestedJobs/${leadId}`),
          CallAPIGetPromise(`/jobs/getAcceptedJobs/${leadId}`)
        ]) as any;
  
        setOpenLeads(openRes?.data || []);
        setRequestedLeads(requestedRes?.data || []);
        setAcceptedLeads(acceptedRes?.data || []);
  
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchLeads();
  }, [refresh]); // ✅ EMPTY ARRAY — runs only once on mount

  useEffect(() => {
    const leadId = searchParams.get('leadId');
    if (!leadId || loading) return;
    const leadExists = [...openLeads, ...requestedLeads, ...AcceptedLeadsList]
      .some((lead: any) => String(lead.id) === leadId);
    if (leadExists) {
      setSelectedLeadId(leadId);
      setCurrentView('lead-details');
    }
  }, [searchParams, loading, openLeads, requestedLeads, AcceptedLeadsList]);

  
  const selectedLead = getSelectedLead();
  const handleCancelApplyLead = () => {
    setPendingLeadId(null);
    setShowApplyConfirmation(false);

  };

  if(getDecodeUserType()==="homeowner"){
    return <LeadListPage />
  }

  if (!canViewJobs) {
    return (
      <div className='page-content tailwind-prefix lead-management-page'>
        <div className="lead-management-shell">
          <div className="mx-auto max-w-3xl">
            <Alert>
              <AlertDescription>
                You do not have permission to view contractor leads.
              </AlertDescription>
            </Alert>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='page-content tailwind-prefix lead-management-page'>
   <div className="lead-management-shell">
      <Toaster position="top-right" />
{ loading ?    <div className="lead-management-loading-overlay"
                       style={{
                         position: "absolute",
                         inset: 0,
                         minHeight:window.innerHeight,
                         backgroundColor: "rgba(255, 255, 255, 0.8)",
                         backdropFilter: "blur(4px)",
                         zIndex: 50,
                         borderRadius: "8px",
                         display: "flex",
                         alignItems: "center",
                         justifyContent: "center",
                       }}
                     >
                       <div
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           alignItems: "center",
                           gap: "12px",
                         }}
                       >
                         <Loader2
                           style={{
                             height: "40px",
                             width: "40px",
                             color: "#1f57d6",
                             animation: "spin 1s linear infinite",
                           }}
                         />
                         <p style={{ fontSize: "14px", color: "#6b7280" }}>Processing...</p>
                 
                         {/* Inline keyframes */}
                         <style>{`
                           @keyframes spin {
                             from { transform: rotate(0deg); }
                             to { transform: rotate(360deg); }
                           }
                         `}</style>
                       </div>
                     </div> :<>
                     
                          {/* Main Content */}
      {currentView === 'leads-pro' && (
        <LeadsPro
          leads={openLeads}
          setShowPlanModal={setShowPlanModal}
          onViewDetails={handleViewDetails}
          onApplyLead={canAcceptJobs ? handleApplyLead : undefined}
          onDeclineLead={canRespondToJobs ? handleDeclineLead : undefined}
          canRespondToJobs={canRespondToJobs}
          canAcceptJobs={canAcceptJobs}
        />
      )}

      {currentView === 'requested-leads' && (
        <RequestedLeads
          leads={requestedLeads}
          onViewDetails={handleViewDetails}
          onAcceptLead={canAcceptJobs ? handleApplyLead : undefined}
          onDeclineLead={canRespondToJobs ? handleDeclineRequestedLead : undefined}
          canRespondToJobs={canRespondToJobs}
          canAcceptJobs={canAcceptJobs}
        />
      )}

     
                     
                     </>}
     
                     {currentView === 'lead-details' && selectedLead && (
        <LeadDetails
          lead={selectedLead}
          onBack={handleBack}
          onDeclineLead={canRespondToJobs ? (location.pathname.includes("pages-projects")? handleDeclineLead:!location.pathname.includes("project-ongoing-leads")?handleDeclineRequestedLead:undefined) : undefined}
          onApplyLead={canAcceptJobs ? handleApplyLead : undefined}
          canRespondToJobs={canRespondToJobs}
          canAcceptJobs={canAcceptJobs}
          showApplyButton={canAcceptJobs && (selectedLead.status === 'open'||selectedLead.status === 'requested')}
        />
      )}
   {currentView === 'accepted-leads' && (
        <AcceptedLeads
          leads={AcceptedLeadsList}
          onViewDetails={handleViewDetails}
          onUpdateStatus={canRespondToJobs ? ()=>{
        setIsRefresh(r=>!r)
          } : undefined}
          onDeclineLead={canRespondToJobs ? async(lead:any)=>{
            let data = {
              projectStatus: "OPEN",
              userId: getDecodeId(),
              leadId: lead.id
            };
          
            try {
              await api.post(`/lead/decline-lead`, data);
              setIsRefresh(r=>!r)
                toast.info("Lead Declined")
          
            } catch (error) {
              setIsRefresh(r=>!r)
              toast.error("Something went wrong")

            }
          } : undefined}
          canRespondToJobs={canRespondToJobs}
        />
      )}
 
        {showApplyConfirmation && (
          <ApplyLeadConfirmation
            leadId={pendingLeadId || ""}
            onConfirm={()=>{
              handleConfirmApplyLead(pendingLeadId)
            }}
            onCancel={handleCancelApplyLead}
          />
        )}
    </div>
    <FeaturePlan showPlanModal={showPlanModal}handleCloseModal={handleCloseModal}step={step}handleChoosePlan={handleChoosePlan}setStep={setStep}selectedPlan={selectedPlan} />
    {showPaymentDeclinedModal && (
   
  String(paymentProvider || "").toLowerCase() === "deluxe" ? (
    <PaymentDeclinedModal
      lead={pendingLead}
      paymentProvider={paymentProvider}
      rejectedCardReson={rejectedCardReson}
      mode={paymentModalMode}
      onClose={() => {
        setIsRefresh(r => !r);
        setShowPaymentDeclinedModal(false);
      }}
      onRetry={() => {}}
      setRejectedReason={setRejectedReason}
    />
  ) : (
    <Elements stripe={isEmployee ? stripePromiseTest : stripePromise}>
      <PaymentDeclinedModal
        lead={pendingLead}
        paymentProvider={paymentProvider}
        rejectedCardReson={rejectedCardReson}
        mode={paymentModalMode}
        onClose={() => {
          setIsRefresh(r => !r);
          setShowPaymentDeclinedModal(false);
        }}
        onRetry={() => {}}
        setRejectedReason={setRejectedReason}
      />
    </Elements>
  )
)}


    </div>
 
  );
}

export default NewLeadsPage
